import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import Notify from "lib/Utils/Alert";
import ReactNotificationAlert from "react-notification-alert";
import Brand from "lib/Core/Backend/Controllers/Brand";

function BestBrandsCtl(props) {
	const { token,suppliersList,supplierSelectRef ,selectRef,setBrandSelectedOption,setSelectedOption,selectedOption,brandSelectedOption,
		setQuantityVal,quantityVal,quantitySelectRef,value,setValue,ValueRef,dateSelectRef,prioritySelectRef,timeLapse,setTimeLapse,priority,setPriority,editOption,setEdit, purchaserIDs,purchaseId,setPurchaseId} = props;
	const [brands, setBrands] = useState([]);
	const [supplierArray, setSupplierArray] = useState([]);
	const brandCtl = useMemo(() => new Brand(token), [token]);
	const brandsSelect = selectRef;
	const supplierSelect = supplierSelectRef;
	const Val = quantitySelectRef;
	const ValueReference = ValueRef;
	const dateReference = dateSelectRef;
	const alert = useRef();


	useEffect(()=>{
		const supplier = suppliersList.filter(supplier => supplier.value !== "Select All");
		setSupplierArray(supplier);

	},[suppliersList])

	function onSupplierSelect(val, operation) {
		switch (operation.action) {
			case "select-option":
				// setPurchaseId(val.id)
				setSelectedOption(val);
				if(val.val === purchaserIDs){
				brandCtl.brandByInvertory(val.val, data=> {
                 if(data && !data.error){
					const brand = data.brands?.map((element) => ({
						value:element?.name,
						label: element?.name,
						id: element?.id,
					  }));
					  setBrands(brand);
				 }else{
					Notify(alert, 'danger', data.errorMessage ?? data.error);
				 }
				})	
				}else{
					brandCtl.brandBySupplier(val.id, data => {
						if (data.error || data.errorMessage) {
							Notify(alert, 'danger', data.errorMessage ?? data.error);
						} else {
							const brand = data
							?.filter((element) => element.brand !== null) 
							.map((element) => ({
							  value: element.brand.name,
							  label: element.brand.name,
							  id: element.brand.id,
							}));
							  setBrands(brand);
						}
	
					});
				}
				
				break;
			case "clear":
				setSelectedOption(null);
				setBrands([]);
				break;
			default:
		}
	}

	
	function clearAll() {
		brandsSelect.current.clearValue();
	}
	function onBrandSelect(val, operation) {
		switch (operation.action) {
			case "select-option":
				setBrandSelectedOption(val);
				
				break;
			case "clear":
				setBrandSelectedOption(null);
				break;
			default:
		}
	}


	return (
		<>
			<ReactNotificationAlert ref={alert} />
			<Form innerRef={props.formRef} onReset={clearAll}>
				<Row form>
					<Col md="6" style={{ position: "relative" }}>
						<FormGroup >
							<Label for="brandId">Supplier</Label>
							<Select
								value={
									selectedOption
								}
								ref={supplierSelect}
								onChange={onSupplierSelect}
								name="supplier"
								id="supplier"
								options={supplierArray}
								isClearable={true}
								isDisabled={editOption}
								/>
						</FormGroup>
					</Col>
					<Col md="6" style={{position:"relative"}}>
						<FormGroup>
							<Label for="quantity">Cumulative Quantity</Label>
							<Input 
							ref={Val}
							type="number"
							value={quantityVal}
							id="quantity"
							onChange={(e)=> setQuantityVal(e.target.value)}
							
							/>
						</FormGroup>
					</Col>
				</Row>

				<Row form>
					<Col md="6" style={{ position: "relative" }}>
						<FormGroup >
							<Label for="brandId">Brand</Label>
							<Select
								value={
								brandSelectedOption
								}
								ref={brandsSelect}
								onChange={onBrandSelect}
								name="brandId"
								id="brandId"
								options={brands}
								isClearable={true} 
								isDisabled={editOption}
								/>
						</FormGroup>
					</Col>
					<Col md="6" style={{position:"relative"}}>
					 <FormGroup>
						<Label for="Value">Cumulative Value</Label>
						<Input 
						ref={ValueReference}
						type="number"
						value={value}
						id="Value"
                        onChange={(e)=>setValue(e.target.value)}
						
						/>
					 </FormGroup>
					</Col>
				</Row>
				<Row form>
                 <Col md="6" style={{position:"relative"}}>
					<FormGroup>
						<Label for="time">Time lapse</Label>
						<Input 
						ref={dateReference}
						type="date"
						id="time"
						value={timeLapse}
						
						onChange={(e)=>setTimeLapse(e.target.value)}
						/>
					</FormGroup>
				 </Col>
				 {/* <Col md="6" style={{position:"relative"}}>
					<FormGroup>
						<Label for="priority">Priority</Label>
						<Input 
						ref={prioritySelectRef}
						type="number"
						id="priority"
						placeholder="Enter brand Priority"
						value={priority}
						
						onChange={(e)=>setPriority(e.target.value)}
						/>
					</FormGroup>
				 </Col> */}
				</Row>
				
			</Form>
		</>
	);
}

export default BestBrandsCtl;